<template>
  <CRow class="justify-content-center">
  <CCol>
    <CCard>
      <CForm @submit.prevent="save">
      <CCardHeader class="pb-4">
        <strong>Biên tập thông tin hợp đồng</strong>
        <div class="card-header-actions">
          <CButton type="submit" color="info" shape="pill" class="mr-2"
          >
            <CIcon name="cil-save"/>
            Lưu
          </CButton>

          <CButton v-if="contractID" type="button" color="secondary" shape="pill" class="mr-2"
                   @click="refreshPage"
          >
            <CIcon name="cil-sync"/>
            Tải lại
          </CButton>

          <CButton v-if="getAllowDeleteButton" type="button" color="danger" shape="pill" class="mr-2"
                   @click="doDelete"
          >
            <CIcon name="cil-trash"/>
            Xóa
          </CButton>

          <CButton type="button" color="secondary" shape="pill" class="mr-2"
                   @click="goBack"
          >
            <CIcon name="cil-chevron-left"/>
            Quay lại
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CInput
          v-if="contract.id"
          label="Số văn bản:"
          type="text"
          :value="contract.id"
          placeholder="Số văn bản"
          horizontal
          :addLabelClasses="'text-right'"
        />

        <CSelect
          label="Khách hàng:"
          :options="customer_names"
          @update:value="handleCustomerNameUpdate"
          :value.sync="contract.customer"
          placeholder="Chọn khách hàng"
          horizontal
          :addLabelClasses="'text-right'"
        />

        <CInput
          label="Hợp đồng:"
          type="text"
          v-model="contract.contract"
          placeholder="Văn bản"
          required
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CInput
          label="Ngày:"
          placeholder="Ngày"
          type="number"
          min="1"
          max="31"
          v-model="contract.day"
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CInput
          label="Tháng:"
          type="number"
          min="1"
          max="12"
          placeholder="Tháng"
          v-model="contract.month"
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CInput
          label="Năm:"
          type="number"
          min="2000"
          max="2050"
          v-model="contract.year"
          placeholder="Năm"
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CTextarea
          label="Nội dung:"
          type="text"
          v-model="contract.content"
          placeholder="Nội dung thực hiện"
          horizontal
          rows="4"
          :addLabelClasses="'text-right'"
        />
        <CInput
          label="Số bản:"
          type="text"
          placeholder="Số bản"
          v-model="contract.copies"
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CInput
          label="Ghi chú:"
          type="text"
          placeholder="Ghi chú"
          v-model="contract.note"
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CRow v-if="contract.docs_file">
          <CCol md="3" class="text-right mt-1 p-0">
            Link tài liệu:
          </CCol>
          <CCol>
            <a :href="contract.docs_link" target="_blank" rel="noopener noreferrer">
              {{ contract.docs_file }}</a>
          </CCol>
        </CRow>
        <CRow class="pt-3">
          <CCol md="3" class="text-right mt-1 p-0">
            Tải tài liệu lên:
          </CCol>
          <CCol sm="6" md="6" lg="6">
            <label
              class="form-control"
              for="fileInputImport"
            >{{ fileNameImport }}
            </label>
            <input type="file"
                   accept=".pdf"
                   id="fileInputImport"
                   style="display: none;"
                   @change="onFileChangeImport">
          </CCol>
          <CCol sm="3" md="3" lg="3">
            <CButton shape="pill" color="info"
                     style="width: 100%;" @click="handleSubmitImport"
                     :disabled="isUploadingImport"
            >
              <CIcon name="cil-cloud-upload"/>
              {{ isUploadingImport ? "Đang tải..." : "Tải lên" }}
            </CButton>
          </CCol>
        </CRow>
        <CRow v-if="isUploadingImport" class="justify-content-center" style="margin-top: 20px">
          <CSpinner
            color="info"
            style="width:2rem;height:2rem;"
          />
        </CRow>
      </CCardBody>
      </CForm>
    </CCard>
  </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      allowDelete: false,
      contractID: '',
      contract: {
        id: 0,
        contract: '',
        day: '',
        month: '',
        year: '',
        copies: '',
        note: '',
        content: '',
        company: '',
      },
      customer_names: [],
      fileNameImport: 'Duyệt tệp',
      selectedFileImport: null, // Holds the selected file object
      isUploadingImport: false,
    };
  },
  created() {
    // console.log(this.$route)
    this.contractID = this.$route.query.id
    this.refreshPage()
  },
  computed: {
    getAllowDeleteButton() {
      return (this.allowDelete && this.contractID)
    }
  },
  methods: {
    refreshPage() {
      // console.log('contractID', this.contractID)
      this.$request.get(`/api/device/contract/${this.contractID}`).
      then(res=>{
        // console.log(res.data)
        this.contract=res.data.contract
        if(res.data.customer_names) {
          this.customer_names = res.data.customer_names.slice(1);
        }
        this.customer_names.push('Tạo mới')
      })
    },
    save() {
      // console.log('Lưu contract: ', this.contract)
      this.$swal.fire({
        title: "Lưu thông tin hợp đồng?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/contract`, this.contract).
          then(res => {
            if(res.data.status === 'success') {
              this.contract = res.data.contract;
              this.$swal.fire({
                icon: "success",
                title: this.contractID ? "Cập nhật thông tin hợp đồng" : "Tạo thông tin hợp đồng mới",
                html: "Lưu thông tin hợp đồng thành công"
              }).then((result) => {
                // out to home to prevent double create when click two times
                if (result.isConfirmed) {
                  if(!this.contractID) {
                    this.goBack()
                  }
                }
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.contractID ? "Cập nhật thông tin hợp đồng" : "Tạo thông tin hợp đồng mới",
                html: "Tạo thông tin hợp đồng " + this.contract.id +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    doDelete() {
      // console.log("Delete contract:", this.contract.id);
      this.$swal.fire({
        title: "Xóa thông tin hợp đồng?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.delete(`/api/device/contract/${this.contract.id}`).
          then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Xóa thông tin hợp đồng",
                html: "Xóa thông tin hợp đồng: " + this.contract.id + " thành công" ,
              });
              this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa thông tin hợp đồng",
                html: "Xóa thông tin hợp đồng: " + this.contract.id +
                  "<br> lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    handleSubmitImport() {
      if (!this.selectedFileImport) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      this.$swal.fire({
        title: "Tải lên đính kèm hợp đồng?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          // Create FormData instance to hold the file
          this.isUploadingImport = true;
          const formData = new FormData();
          formData.append("file", this.selectedFileImport);
          formData.append("id", this.contract.id);
          // Send file using Axios
          this.$request.post("/api/device/contract/uploaddocs", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }).then((res) => {
            if (res.data.status === 'success') {
              // console.log(res.data.status)
              this.$swal.fire({
                icon: "success",
                title: "Tải lên tệp",
                text: "Tệp: " + this.fileNameImport + " đã tải lên thành công!",
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Tải lên tệp",
                html: "Tệp: " + this.fileNameImport + " tải lên lỗi: " + res.data.status,
              });
            }
            this.isUploadingImport = false;
            this.refreshPage()
          }).catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Tải lên tệp",
              html: "Tệp: " + this.fileNameImport + " tải lên lỗi: " + error,
            });
            this.isUploadingImport = false;
          });
        }
      });
    },
    onFileChangeImport(event) {
      this.selectedFileImport = event.target.files[0];
      if (this.selectedFileImport) {
        this.fileNameImport = this.selectedFileImport.name;
        // console.log('selected file name:', this.fileNameImport)
      } else {
        // console.log('no file selected');
        this.fileNameImport = 'Duyệt tệp'
      }
    },
    handleCustomerNameUpdate(newValue) {
      if (newValue === 'Tạo mới') {
        this.newCustomer()
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  },
};
</script>

<style>

</style>
